import { useState } from 'react';
import { Button } from '../../../components/ui';
import { useAppContext } from '../../../contexts/AppContext';
import { useOrganization } from '../../../contexts/OrganizationContext';
import { endAdminImpersonation } from '../../../services/modules/superadmin/superadminApi';
import { SuperadminApiError } from '../../../services/modules/superadmin/errors';
import { notify } from '../../../utils/toast';
import { useSupportSession } from '../hooks/useSupportSession';

export function SupportModeBanner() {
    const { openSuperadminOrg } = useAppContext();
    const { refreshOrganizations } = useOrganization();
    const { session, clear } = useSupportSession();
    const [isEnding, setIsEnding] = useState(false);

    if (!session) return null;

    const handleExit = async () => {
        if (isEnding) return;
        setIsEnding(true);
        const orgId = session.organizationId;

        try {
            await endAdminImpersonation(session.sessionId);
            clear();
            await refreshOrganizations(true);
            openSuperadminOrg(orgId);
        } catch (e) {
            notify.error(
                e instanceof SuperadminApiError
                    ? e.message
                    : 'Falha ao encerrar modo manutenção',
            );
        } finally {
            setIsEnding(false);
        }
    };

    return (
        <div
            className="flex shrink-0 items-center justify-between gap-s3 border-b border-amber-300/60 bg-amber-50 px-s4 py-2 text-sm text-amber-950"
            role="status"
            aria-live="polite"
        >
            <span className="font-medium">
                Modo manutenção · {session.organizationName}
            </span>
            <Button
                type="button"
                variant="outline"
                size="sm"
                className="h-7 border-amber-400 bg-white/80 text-amber-950 hover:bg-white"
                onClick={() => void handleExit()}
                disabled={isEnding}
            >
                {isEnding ? 'Saindo…' : 'Sair'}
            </Button>
        </div>
    );
}
